// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b9b9f6ad","791":"a9ae116a"}[chunkId] + ".chunk.js";
};